import { AddressDeliveryType } from '../../../../models/address-delivery-type';
import client from '../../client';

const addressBranch = async (
  sessionId: string
): Promise<AddressDeliveryType[]> => {
  const { data } = await client.get<AddressDeliveryType[]>('/address/branch', {
    params: { provider: 0, sessionId },
  });

  return data;
};

export default addressBranch;
